module.exports = __webpack_public_path__ + "img/agente_digital.18851e5f.svg";